/* eslint-disable react/no-array-index-key */
import { css, jsx } from '@emotion/core';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import { handleFormChange } from '@/src/register/redux/registerAccountReducer';

import Checkbox from './components/Checkbox';
import CountryInput from './components/Country';
import Dropdown from './components/Dropdown';
import EmailAddressInput from './components/EmailAddressInput';
import InformalNameCheckbox from './components/InformalNameCheckbox';
import Input from './components/Input';
import MailingStateInput from './components/MailingState';
import OfficeStateInput from './components/OfficeState';
import PasswordInput from './components/PasswordInput';
import TextArea from './components/TextArea';

const styles = {
  formContainer: css`
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0.8rem 0;
  `,
};

const InputForm = props => {
  const { fieldInfo, form, step } = props;

  const dispatch = useDispatch();

  const [isUS, setIsUS] = useState(false);

  const onChange = (field, e) => {
    if (typeof e === 'string' || e instanceof String || !e || typeof e === 'number') {
      dispatch(handleFormChange({ name: field, value: e }));
    } else {
      const {
        target: { value },
      } = e;
      dispatch(handleFormChange({ name: field, value }));
    }

    // Add validation rules to zip codes if the country is the USA
    if (field === 'CountryCode') {
      const isUSA = e === 'USA';

      setIsUS(isUSA);

      const zipStep = 1;
      const zipIndex = fieldInfo[zipStep].findIndex(f => f.field === 'PostalCode');
      const poZipIndex = fieldInfo[zipStep].findIndex(f => f.field === 'PoBoxPostalCode');

      if (zipStep >= 0 && zipIndex >= 0) {
        const regex = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/);
        if (isUSA) {
          fieldInfo[zipStep][zipIndex]['formOverrides']['rules'][0]['pattern'] = regex;
          fieldInfo[zipStep][poZipIndex]['formOverrides']['rules'][0]['pattern'] = regex;
        } else {
          delete fieldInfo[zipStep][zipIndex]['formOverrides']['rules'][0]['pattern'];
          delete fieldInfo[zipStep][poZipIndex]['formOverrides']['rules'][0]['pattern'];
        }
      }
    }
  };

  const onKeyPress = (field, e) => {
    const isPhone = field === 'Number' || field === 'Mobile' || field === 'FaxNumber';
    if (isPhone) {
      const nonPhoneChars = new RegExp('[^0-9()-. ]', 'i');
      if (nonPhoneChars.test(e.key)) {
        e.preventDefault();
      }
    }

    const isZip = field === 'PostalCode' || field === 'PoBoxPostalCode';
    if (isZip) {
      const nonZipChars = new RegExp('[^0-9-]');
      if (isUS && nonZipChars.test(e.key)) {
        e.preventDefault();
      }
    }
  };

  const renderFields = () => {
    return fieldInfo[step].map((info, index) => {
      switch (info.type) {
        case 'dropdown':
          return (
            <Dropdown
              key={`${info.label}-${index}`}
              info={info}
              step={step}
              form={form}
              onChange={onChange}
            />
          );
        case 'input':
          return (
            <Input
              key={`${info.label}-${index}`}
              info={info}
              step={step}
              form={form}
              onChange={onChange}
              onKeyPress={onKeyPress}
            />
          );
        case 'checkbox':
          return <Checkbox key={`${info.label}-${index}`} info={info} step={step} form={form} />;
        case 'informalNameCheckbox':
          return (
            <InformalNameCheckbox
              key={`${info.label}-${index}`}
              info={info}
              step={step}
              form={form}
            />
          );
        case 'inputPassword':
          return (
            <PasswordInput
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        case 'inputEmail':
          return (
            <EmailAddressInput
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        case 'inputCountry':
          return (
            <CountryInput
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        case 'inputMailingState':
          return (
            <MailingStateInput
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        case 'inputOfficeState':
          return (
            <OfficeStateInput
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        case 'adminComment':
          return (
            <TextArea
              key={`${info.label}-${index}`}
              step={step}
              info={info}
              form={form}
              onChange={onChange}
            />
          );
        default: {
          console.warn(`${info.type} is an unknown type.`);
          return null;
        }
      }
    });
  };

  return <div css={styles.formContainer}>{renderFields()}</div>;
};

export default InputForm;

/*

        case 'inputDropdown':
          return <InputDropdown key={`${info.label}-${index}`} info={info} step={step} />;
        case 'inputTree':
          return <InputTree key={`${info.label}-${index}`} step={step} info={info} />;


*/
